export default (num, round=2) => {
    num = num.toString()
    const dif = num[0] === '-' ? '-' : ''
    num = num.replace('-', '')

    if ( num.includes('e') ) num = num.slice(0, 10)
    if ( !num.includes('.') ) return num
    
    const numIndex = num.match(/[^0\.]/).index //checking for any symbols but 0 or .

    if (num.split('.')[0].length > 1 || num.split('.')[0] !== '0') {
        num = +num
        return dif + num.toFixed(round)
    } else {
        return dif + num.slice(0, numIndex + round)
    }
}